import { Link } from 'react-router-dom';
import styles from './LegalPage.module.css';

export function ContactPage() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Link to="/" className={styles.backLink}>← Back to Home</Link>
        
        <h1 className={styles.title}>Contact Us</h1>

        <section className={styles.section}>
          <h2>General Inquiries</h2>
          <p>
            For general questions about Omen SEO, please 
            contact us at:
          </p>
          <p className={styles.contactInfo}>
            <a href="mailto:support@omensystems.com">support@omensystems.com</a>
          </p>
        </section>

        <section className={styles.section}>
          <h2>Technical Support</h2>
          <p>
            For technical issues, bug reports, or feature requests:
          </p>
          <p className={styles.contactInfo}>
            <a href="mailto:support@omensystems.com">support@omensystems.com</a>
          </p>
        </section>

        <section className={styles.section}>
          <h2>Billing Inquiries</h2>
          <p>
            For questions about subscriptions, payments, or invoices:
          </p>
          <p className={styles.contactInfo}>
            <a href="mailto:billing@omensystems.com">billing@omensystems.com</a>
          </p>
        </section>

        <section className={styles.section}>
          <h2>Privacy Concerns</h2>
          <p>
            For privacy-related inquiries or data requests:
          </p>
          <p className={styles.contactInfo}>
            <a href="mailto:privacy@omensystems.com">privacy@omensystems.com</a>
          </p>
        </section>

        <section className={styles.section}>
          <h2>Company Information</h2>
          <p>
            <strong>Omen SEO</strong><br />
            A product by OmenSystems<br />
            <a href="https://omensystems.com" target="_blank" rel="noopener noreferrer">
              omensystems.com
            </a>
          </p>
        </section>

        <section className={styles.section}>
          <h2>Response Time</h2>
          <p>
            We aim to respond to all inquiries within 1-2 business days. For urgent 
            technical issues affecting service availability, please include "URGENT" 
            in your subject line.
          </p>
        </section>
      </div>
    </div>
  );
}
